import React from 'react';

const UserInfoFormModal = React.lazy(() => import('../components/FormModal'));
const userInfoModalRegistry = {
    crm_userInfoId: UserInfoFormModal
};
export default userInfoModalRegistry;
